import React from 'react';
import { motion } from 'framer-motion';

function SectionWithImage({ title, imageSrc, imagePosition, points }) {
  return (
    <section className="flex flex-col lg:flex-row items-center gap-12">
      {imagePosition === 'left' && (
        <motion.div 
          className="lg:w-1/2"
          initial={{ x: -50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-[#C334F6]/20 to-[#543DF4]/20 rounded-2xl blur-2xl" />
            <img 
              src={imageSrc} 
              alt={title} 
              className="w-full h-auto rounded-2xl relative z-10 shadow-2xl"
            />
          </div>
        </motion.div>
      )}
      
      <motion.div 
        className={`lg:w-1/2 ${imagePosition === 'left' ? 'lg:pl-8' : 'lg:pr-8'}`}
        initial={{ x: imagePosition === 'left' ? 50 : -50, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <motion.h2 
          className="text-4xl font-medium leading-[1.2] tracking-[0.001em] text-white mb-8"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          {title}
        </motion.h2>
        
        <ul className="space-y-8">
          {points.map((point, index) => (
            <motion.li 
              key={index} 
              className="flex items-start"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
            >
              <div className="relative mr-4 mt-1">
                <div className="absolute inset-0 bg-gradient-to-r from-[#C334F6]/20 to-[#543DF4]/20 rounded-full blur-sm" />
                <img 
                  src={point.icon} 
                  alt="" 
                  className="w-8 h-8 relative z-10"
                />
              </div>
              <p className="text-xl font-normal leading-[1.5] tracking-[0.002em] text-white/90">
                {point.text}
              </p>
            </motion.li>
          ))}
        </ul>
      </motion.div>

      {imagePosition === 'right' && (
        <motion.div 
          className="lg:w-1/2"
          initial={{ x: 50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-[#C334F6]/20 to-[#543DF4]/20 rounded-2xl blur-2xl" />
            <img 
              src={imageSrc} 
              alt={title} 
              className="w-full h-auto rounded-2xl relative z-10 shadow-2xl"
            />
          </div>
        </motion.div>
      )}
    </section>
  );
}

export default SectionWithImage;
